package com.ilussobsa.views

import com.ilussobsa.Strings
import com.ilussobsa.sdk.currentUserSessionNullable
import com.ilussobsa.utils.checkCircle
import com.ilussobsa.utils.emptyCircle
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.models.Icon
import com.lightningkite.kiteui.models.px
import com.lightningkite.kiteui.models.rem
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.reactive.WindowInfo
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.children
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

@Routable("/tutorials")
class TutorialsScreen() : Page {
    val checklist = remember {
        TutorialItem.values().map { it to (currentUserSessionNullable()?.me?.invoke()?.tutorialsComplete?.contains(it.name) ?: false) }
    }
    override val title: Reactive<String>
        get() = remember { Strings.tutorialsXY(checklist().count { it.second }, TutorialItem.values().size) }
    override fun ViewWriter.render() = col {
        expanding - recyclerView {
            ::columns { (WindowInfo().width.px / 350).toInt() + 1 }
            children(checklist, id = { it.first }) {
                card - link {
                    spacing = 0.px
                    card - col {
                        spacing = 0.px
                        padded - frame {
                            centered - icon {
                                ::source { it().first.icon.copy(width = 5.rem, height = 5.rem) }
                            }
                        }
                        card - row {
                            centered - icon {
                                ::source { if(it().second) Icon.checkCircle else Icon.emptyCircle }
                            }
                            centered - text { ::content { it().first.title } }
                        }
                    }
                    ::to { val id = it().first; { TutorialScreen(id) } }
                }
            }
        }
    }
}